// ---------------------------------------------------------
// Datei: browser.ts
// Zweck: Grobe Browsererkennung per User-Agent für UI-Hinweise,
//        die sich nicht per Feature-Detection abbilden lassen.
// ---------------------------------------------------------

/**
 * Erkennt Desktop-Chrome (nicht Android/iOS, nicht Edge/Opera, die
 * ebenfalls "Chrome/" im User-Agent führen). Chrome hat für FedCM
 * getrennte Implementierungen für Desktop und Android - der aktuelle
 * One-Tap-Bug betrifft nachweislich nur die Desktop-Variante.
 */
export function isDesktopChrome(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const isChrome = /Chrome\//.test(ua) && !/Edg\//.test(ua) && !/OPR\//.test(ua) && !/CriOS\//.test(ua);
  const isMobile = /Mobi|Android/.test(ua);
  return isChrome && !isMobile;
}

/**
 * Erkennt Browser, für die Google One Tap wegen Intelligent Tracking Prevention
 * (ITP) den interaktiven itp_support-Flow (Welcome-Page -> Popup) statt des
 * stillen Cookie-Checks nutzt: Safari (Desktop), jeder Browser unter iOS (dort
 * laufen alle Engines auf WebKit, Apples Vorgabe) sowie Firefox - Google führt
 * Firefox in derselben ITP-Kategorie, siehe
 * https://developers.google.com/identity/gsi/web/guides/integrate#one_tap_on_itp_browsers.
 */
export function isItpBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua);
  const isMacSafari = /Safari\//.test(ua) && !/Chrome\/|CriOS\/|FxiOS\/|Edg\//.test(ua) && !/Android/.test(ua);
  const isFirefox = /Firefox\//.test(ua) && !/Seamonkey\//.test(ua);
  return isIOS || isMacSafari || isFirefox;
}
